import { render, staticRenderFns } from "./RequiredAlert.vue?vue&type=template&id=f2d91286"
import script from "./RequiredAlert.vue?vue&type=script&lang=js"
export * from "./RequiredAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports